import { render, staticRenderFns } from "./monthly-calendar-week.vue?vue&type=template&id=3d2d831a&"
import script from "./monthly-calendar-week.vue?vue&type=script&lang=ts&"
export * from "./monthly-calendar-week.vue?vue&type=script&lang=ts&"
import style0 from "./monthly-calendar-week.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports